// client/src/services/documentService.js

import authService from './authService';

const apiUrl = process.env.REACT_APP_API_URL || '/api';

const authHeaders = (extra = {}) => ({
  ...extra,
  Authorization: `Bearer ${authService.getToken()}`
});

const checkUnauthorized = (response) => {
  if (response.status === 401) authService.handleUnauthorized();
};

const getDocuments = async (filters = {}, page = 1, limit = 50) => {
  const params = new URLSearchParams({ page, limit });
  if (filters.category) params.append('category', filters.category);
  if (filters.tag) params.append('tag', filters.tag);
  if (filters.from) params.append('from', filters.from);
  if (filters.to) params.append('to', filters.to);
  if (filters.search) params.append('search', filters.search);

  const response = await fetch(`${apiUrl}/documents?${params.toString()}`, {
    headers: authHeaders()
  });
  checkUnauthorized(response);
  if (!response.ok) throw new Error('Erreur lors du chargement des documents.');
  return await response.json();
};

// FormData : pas de Content-Type (le navigateur le génère avec le boundary)
const uploadDocument = async ({ file, title, category, tags, documentDate }) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('title', title);
  formData.append('category', category);
  formData.append('tags', JSON.stringify(tags || []));
  if (documentDate) formData.append('documentDate', documentDate);

  const response = await fetch(`${apiUrl}/documents`, {
    method: 'POST',
    headers: authHeaders(),
    body: formData
  });
  checkUnauthorized(response);
  const result = await response.json();
  if (!response.ok) throw new Error(result.message || "Erreur lors de l'envoi du document.");
  return result;
};

const updateDocument = async (id, data) => {
  const response = await fetch(`${apiUrl}/documents/${id}`, {
    method: 'PATCH',
    headers: authHeaders({ 'Content-Type': 'application/json' }),
    body: JSON.stringify(data)
  });
  checkUnauthorized(response);
  const result = await response.json();
  if (!response.ok) throw new Error(result.message || 'Erreur lors de la mise à jour.');
  return result;
};

const deleteDocument = async (id) => {
  const response = await fetch(`${apiUrl}/documents/${id}`, {
    method: 'DELETE',
    headers: authHeaders()
  });
  checkUnauthorized(response);
  if (!response.ok) {
    const result = await response.json().catch(() => ({}));
    throw new Error(result.message || 'Erreur lors de la suppression.');
  }
};

// Le visionnage passe par un Blob : un <iframe>/<a> ne peut pas envoyer le
// header Authorization qu'exige la route protégée /documents/:id/file.
const fetchFileBlobUrl = async (id) => {
  const response = await fetch(`${apiUrl}/documents/${id}/file`, { headers: authHeaders() });
  checkUnauthorized(response);
  if (!response.ok) throw new Error('Erreur lors du chargement du fichier.');
  const blob = await response.blob();
  return URL.createObjectURL(blob);
};

const documentService = {
  getDocuments,
  uploadDocument,
  updateDocument,
  deleteDocument,
  fetchFileBlobUrl
};

export default documentService;
